import SvgIcon from '@/components/Icon/Icon.vue'
import store from '@/store/index.js'

const svgRequired = require.context('./svg', false, /\.svg$/)
svgRequired.keys().forEach(item => svgRequired(item));

export default (app) => {
    app.component('svg-icon', SvgIcon)
}


// 把icon的名字单独筛选出来一个数组
const iconNames = svgRequired.keys().map((key) => {
    // 示例 key 为 ./home.svg
    // 移除开头的 './' 得到 'home.svg'
    const withoutPrefix = key.slice(2);
    // 移除末尾的 '.svg' 得到 'home'
    return withoutPrefix.slice(0, -4);
});
store.commit('setRequiredIconNameList', iconNames)




